// Import model
import { FilterProposalRequest } from '../models/FilterProposalRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ProposalCondition } from '../models/ProposalCondition';
import { ProposalFields } from '../models/ProposalFields';
import { ProposalIndexedFields } from '../models/ProposalIndexedFields';

// Import dependency serializers (for complex types)
import { ProposalConditionSerializer } from './ProposalConditionSerializer';
import { ProposalFieldsSerializer } from './ProposalFieldsSerializer';
import { ProposalIndexedFieldsSerializer } from './ProposalIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterProposalRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterProposalRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterProposalRequest instance
   */
  static deserialize(json: string): FilterProposalRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterProposalRequest instance
   */
  static fromObject(obj: any): FilterProposalRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterProposalRequest');
    }


    const instance: FilterProposalRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ProposalIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ProposalFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ProposalConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterProposalRequest instances
   */
  static deserializeArray(json: string): FilterProposalRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterProposalRequest instance to a JSON string
   */
  static serialize(instance: FilterProposalRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterProposalRequest instance to a plain object
   */
  static toObject(instance: FilterProposalRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ProposalConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterProposalRequest instances to a JSON string
   */
  static serializeArray(instances: FilterProposalRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
